"use strict";

exports.__esModule = true;
exports.SERIES_CLASS = exports.ACTIVE_SERIES_CLASS = void 0;

require("./index.css");

var ACTIVE_SERIES_CLASS = 'mw-visualization-tooltip__point-hover';
exports.ACTIVE_SERIES_CLASS = ACTIVE_SERIES_CLASS;
var SERIES_CLASS = 'mw-visualization-tooltip__point';
exports.SERIES_CLASS = SERIES_CLASS;